
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create/aiDesign",
      function () {
        return require("private-next-pages/create/aiDesign.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create/aiDesign"])
      });
    }
  